import {useQuery, UseQueryOptions} from "@tanstack/react-query";
import api from "../lib/api";

type PaymentStatus = "success" | "failed" | "pending" | "canceled";

export type PaymentDetails = {
    status: PaymentStatus;
    reference: string;
    description: string;
    entries: number;
    amount: number;
    currency: string;
}

async function fetchOrderStatus(reference: string): Promise<PaymentDetails> {
    return api.get(`/api/v1/public/competitions/orders/status/${encodeURIComponent(reference)}`)
        .then(({data}) => data as PaymentDetails);
}

type UseOrderByRefOpts = {
    reference: string;
    queryOptions?: Omit<
        UseQueryOptions<PaymentDetails, Error, PaymentDetails, any[]>,
        "queryKey" | "queryFn"
    >
}

export function useOrderByRef(opts: UseOrderByRefOpts) {
    const {reference} = opts;
    // @ts-ignore
    return useQuery<PaymentDetails, Error>({
        queryKey: ["order-by-ref", reference],
        queryFn: () => fetchOrderStatus(reference),
        enabled: !!reference,
        refetchOnWindowFocus: false,
        retry: 1,
        ...opts.queryOptions,
    });
}